import NeveLearningLogoMonochrome from 'assets/icons/footer/NeveLearningLogoMonochrome';
import styled from 'styled-components';
import { theme, sizes } from 'theme';

export default function FooterWhiteLogo() {
    return (
        <FooterBackground>
            <NeveLearningLogoMonochrome />
        </FooterBackground>
    );
}

const FooterBackground = styled.div`
    background-color: ${theme.footerBackground};
    padding: ${sizes.spacingLg} 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
